/* ERISO country / currency picker + first-visit country detection */
(function () {
  var STORAGE_KEY = 'eriso-country-chosen';

  function remember() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }
  function alreadyChosen() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return true; }
  }

  var pickers = document.querySelectorAll('[data-country-picker]');

  // Close an open picker when clicking elsewhere or pressing Escape.
  document.addEventListener('click', function (event) {
    pickers.forEach(function (picker) {
      if (picker.open && !picker.contains(event.target)) picker.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    pickers.forEach(function (picker) {
      if (picker.open) {
        picker.open = false;
        picker.querySelector('summary').focus();
      }
    });
  });

  // A manual choice always wins over detection.
  document.querySelectorAll('[data-country-form]').forEach(function (form) {
    form.addEventListener('submit', remember);
  });

  // First visit only: switch to the visitor's own country if we sell in its currency.
  var form = document.querySelector('[data-country-form]');
  if (!form || alreadyChosen()) return;
  if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent)) return;

  var current = window.Shopify && window.Shopify.country;
  var available = Array.prototype.map.call(form.querySelectorAll('[name="country_code"]'), function (b) { return b.value; });
  remember();

  fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
    'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(current || ''))
    .then(function (response) { return response.json(); })
    .then(function (data) {
      var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (!detected || detected === current || available.indexOf(detected) === -1) return;
      var body = new FormData(form);
      body.set('country_code', detected);
      return fetch(form.action, { method: 'POST', body: body, credentials: 'same-origin' }).then(function () {
        window.location.reload();
      });
    })
    .catch(function () {});
})();
